
export const GETLASTCOURSESTATE = 'GETLASTCOURSESTATE';
export const DELETELASTCOURSESTATE = 'DELETELASTCOURSESTATE';

const intialState = {
    selectedFile: 0,
    selectedModule: 0,
};
const lastCourseStateReducer = (state = intialState, action) => {
    switch (action.type) {
        case GETLASTCOURSESTATE:
            return Object.assign({}, state, action.payload);
        case DELETELASTCOURSESTATE:
            return intialState;
        default:
            return state;
    }
};
export default lastCourseStateReducer;